import "slick-carousel";
import PricingContactForm from "./pricing-contact-form";
import MultistepPricingContactForm from "./multistep-pricing-contact-form";
import {debounce, getParameterByName, throttle, equalHeight} from "../utils";
import PricingCalculator from "./pricing-calculator";
import PricingABTest from "./pricing-ab-test";
import GAService from "./GAService";

export default class BusinessPricing {
  constructor(container, loadMode = false, showBusinessIntent = true, currentPlanIndex = 0) {
    this.$pricing = $(container);
    this.translations = window.pricing_translations;
    this.showBusinessIntent = showBusinessIntent;

    if (this.$pricing.length === 0) {
      return;
    }

    this.currentPlanIndex = currentPlanIndex;

    this.init();

    const mode = getParameterByName("mode");

    if (mode) {
      this.mode = mode;
      this.switchMode(mode);
    } else {
      if (loadMode && !window.disable_auto_mode) {
        this.fetchMode();
      } else {
        this.mode = window.mode || "individual";
        this.switchMode(this.mode);
      }
    }

  }

  init() {
    this.period = window.period || "monthly";
    // this.mode = window.mode || "individual";
    this.periodsAvailable = window.pricing_periods || ['monthly', 'yearly'];
    this.discount = window.discount || 0;
    this.discountedPlans = [];
    this.isComparisonOpen = false;
    this.breakpoint = 768;
    this.mobileMediaQuery = window.matchMedia(`(max-width: ${this.breakpoint - 1}px)`);
    this.centerPlanOffsetBreakpoint = 960;
    this.addCenterBoxOffset =
      $(window).width() >= this.centerPlanOffsetBreakpoint;
    this.isPartnershipPage =
      typeof this.$pricing.data("partner-page") !== "undefined";
    this.comparisonData = window.comparison_rows;
    this.allPlans = window.all_plans;
    // this.currentPlanIndex = 0;
    this.mobilePricingFirstPlan = window.mobilePricingFirstPlan ?? 1;
    this.is_christmas_promo_active = window.is_christmas_promo_active;
    this.is_bfcm_promo_active = window.window.is_bfcm_promo_active;

    this.$pricingBar = this.$pricing.find(".pricing-bar");
    this.$pricingSwitcher = this.$pricing.find(".price-switcher");
    this.$modeSwitcher = this.$pricing.find(".mode-switcher");
    this.$businessDoodle = this.$pricing.find("[data-business-doodle]");
    this.$pricingLoadWrapper = this.$pricing.find(".pricing__load-wrapper");
    this.$comparisonSwitcher = this.$pricing.find(
      ".pricing-comparison-switcher .text-btn"
    );
    this.$slider = this.$pricing.find(".pricing-overview__boxes-wrapper");
    this.$comparisonSilder = this.$pricing.find('.pricing-head__plans-container');
    this.$mobilePricing = this.$pricing.find(".pricing-mobile");
    this.$desktopPricing = this.$pricing.find(".pricing-desktop");
    this.pricingContactForm = new MultistepPricingContactForm();

    if (this.isPartnershipPage) {
      this.partnerName = window.partnerName;
    }

    if (window.custom_label_appearance) {
      this.custom_label_appearance = window.custom_label_appearance;
    }

    if (!this.showBusinessIntent) {
      this.$businessDoodle.hide();
    }

    const couponFromParameter = getParameterByName("coupon");

    if (couponFromParameter) {
      window.registration_data.coupon = couponFromParameter;
    }

    this.requestCallChatOpened = false;

    this.handleLocalPricingTest();
    this.computeOffsets();
    this.makeOverviewSectionsEqualHeight();
    this.loadPrices();
    this.handlePricingBar();
    this.handleSwitchingPeriod();
    this.handleSwitchingMode();
    this.handleOpeningComparison();
    this.handleRegistration();
    this.handleContactForm();
    this.handleComparisonCollapse();
    this.setupABTest();

    this.overrideGuruMedia();

    this.initSlick();

    window.addEventListener(
      "resize",
      debounce(() => this.onResize(), 300)
    );
    window.addEventListener(
      "scroll",
      throttle(() => this.onScroll(), 1000)
    );
    window.addEventListener("transitionend", (e) => {
      const { propertyName, target } = e;

      if (
        $(target).hasClass("mode-switcher__slider") &&
        propertyName === "transform"
      ) {
        this.$pricingLoadWrapper.css("opacity", 1);
      }
    });
  }

  get isMobile() {
    return this.mobileMediaQuery.matches;
  }

  onResize() {
    this.initSlick();
    this.computeOffsets();
    this.makeOverviewSectionsEqualHeight();
  }

  onScroll() {
    this.computeOffsets();
  }

  handleLocalPricingTest() {
    if (!this.isPartnershipPage && window.localized_pricing_test) {
      $.get('https://api.ipdata.co/?api-key=2d353eb1fb42b6c8af5ba73ef8b3d783bf41d1a31f13b72828431532', (data) => {
        this.loadLocalizedPricing(data.country_code);
      });
    }
  }

  computeOffsets() {
    const $comparison = this.$pricing.find(".pricing-comparison");
    const $priceWrapper = this.$pricing.find(".overview-box__price-wrapper");
    const $boxesWrapper = this.$pricing.find(
      ".pricing-overview__boxes-wrapper"
    );

    this.pricingPriceOffset = $priceWrapper.offset().top;
    this.pricingBoxesOffset = $boxesWrapper.offset().top;

    if ($comparison.length && $comparison.offset().top > 0) {
      this.pricingBottomOffset =
        $comparison.offset().top + $comparison.outerHeight() - 117;
    } else {
      this.pricingBottomOffset =
        this.pricingBoxesOffset + $boxesWrapper.outerHeight() - 117;
    }
  }

  makeOverviewSectionsEqualHeight() {
    const $overviewSections = this.$slider;

    // header section
    equalHeight(".overview-box__description");
    equalHeight(".overview-box__old-price");
    equalHeight(".overview-box__btn");
    equalHeight(".overview-box__btn--second");

    // 'normal' plans features section 1 & 2
    equalHeight(".overview-box__list--1");
    equalHeight(".overview-box__list--2");

    // equal entire features section (normal plans and agency plan)
    if ($(".overview-box--agency").length > 0) {
      equalHeight(".overview-box__features-wrapper");
    }

    if (this.$pricing.hasClass('equal-li-elements')) {
      for (let j = 1; j <= 2; j++) {
        for (let i = 0; i < $(`.overview-box__list--${j} .overview-box__list-item`).length; i++) {
          equalHeight(`.overview-box__list--${j} .overview-box__list-item:nth-child(${i})`);
        }
      }
    }
  }

  handleComparisonCollapse() {
    this.$mobilePricing.find(".pricing-collapse__heading").click((e) => {
      const $collapse = $(e.currentTarget).parent();
      $collapse.toggleClass("pricing-collapse--open");

      this.computeOffsets();
    });
  }

  handlePricingBar() {
    this.$pricingBar.find(".pricing-bar__plan").click((e) => {
      // if it's used for mode switching (teased start up plan) then do nothing
      if (!$(e.currentTarget).data("modeSwitch")) {
        e.preventDefault();
        if (this.canSlide) {
          this.choosePlan($(e.currentTarget).data("index"));
        }
      }
    });
  }

  choosePlan(index, slideToPlan = true) {
    if (this.$slider.hasClass("slick-initialized") && slideToPlan) {
      let newIndex = index - (this.mode === 'business' ? 3 : 0);
      if ((index >= 3 && this.mode === 'individual') || (index < 3 && this.mode === 'business')) {
        newIndex = 0;
      }
      this.$slider.slick("slickGoTo", newIndex);
    }

    this.$pricingBar
      .find(".pricing-bar__plan:eq(" + this.currentPlanIndex + ")")
      .removeClass("pricing-bar__plan--active");

    this.$pricingBar
      .find(".pricing-bar__plan:eq(" + index + ")")
      .addClass("pricing-bar__plan--active");

    this.currentPlanIndex = index;
    const currentPlanName = this.$pricingBar
      .find(".pricing-bar__plan:eq(" + index + ")").data('plan');

    this.$mobilePricing.find(".pricing-row").each((i, element) => {
      const $row = $(element);
      $row.find(".pricing-row__cell").html(this.comparisonData[i][currentPlanName]);
    });

    const planName = this.$pricingBar
      .find(".pricing-bar__plan:eq(" + index + ")")
      .data("plan");
    const discountLabel =
      this.discount > 0 ? "discount_" + this.discount : "base";
    const period = this.period;

    let price = prices[discountLabel][period][planName];

    this.$pricingBar
      .find("[data-price]")
      .text(price);

    let periodText = period === "monthly" ? '' : (period === "6-months" ? 'billed semi-annually' : this.translations.billed);

    this.$pricingBar.find("[data-price-period]").html(periodText);
    this.$mobilePricing.show();
  }

  loadPrices() {

    if (
      window.registration_data &&
      window.registration_data.coupon &&
      window.api_domain
    ) {
      let coupon = window.registration_data.coupon;
      $.ajax(
        `${window.api_domain}payment/coupon/${encodeURIComponent(
          coupon
        )}/validate`,
        {
          type: "POST",
          success: (couponData) => {
            this.fillPrices(couponData);
          },
        }
      );

    // TESTING LOCALLY 
    // let couponData = {
    //   "code" : "affLIFT,30%,12,months,-9JCi-RnmT",
    //   "type" : "PERCENT_OFF",
    //   "percentOff" : 30,
    //   "overrides" : [ {
    //     "plan" : "ANNUAL_PROFIT_Q224",
    //     "value" : 7
    //   }, {
    //     "plan" : "ANNUAL_SCALE_Q224",
    //     "value" : 5
    //   }, {
    //     "plan" : "START_UP_Q323",
    //     "value" : 5
    //   }, {
    //     "plan" : "ANNUAL_START_UP_Q323",
    //     "value" : 2
    //   }, {
    //     "plan" : "AGENCY_Q123",
    //     "value" : 6
    //   }, {
    //     "plan" : "ANNUAL_AGENCY_Q123",
    //     "value" : 6
    //   }, {
    //     "plan" : "ENTERPRISE_Q123",
    //     "value" : 5
    //   }, {
    //     "plan" : "ANNUAL_ENTERPRISE_Q123",
    //     "value" : 3
    //   } ]
    // };
    // this.fillPrices(couponData);
    // TESTING LOCALLY END
    
    } else {
      this.updateData();
    }
  }

  loadLocalizedPricing(countryCode) {
    const countries = {
      'GB': {
        'conversion': window.exchange_rates.USDGBP,
        'currencyLetter': '£',
        'currencyCode': 'GBP'
      },
      'DE': {
        'conversion': window.exchange_rates.USDEUR,
        'currencyLetter': '€',
        'currencyCode': 'EUR',
      },
      // 'PL': { //PL WAS FOR THE TEST
      //   'conversion': window.exchange_rates.USDPLN,
      //   'currencyLetter': 'zł',
      //   'currencyCode': 'PLN'
      // }
    };

    if (Object.keys(countries).includes(countryCode)) {
      this.$pricing.find('.overview-box__price-dollar-sign,.pricing-head__plan-price-dollar,.pricing-bar__info-from').text(countries[countryCode].currencyLetter);
      this.$pricing.find('.overview-box__price-period').addClass('overview-box__price-period--asterix');
      this.$pricing.find('.pricing-overview__info').text('* This is an estimated price in your local currency. The payment will be processed in USD. You will see the final price in USD in the next step before finalizing payment.');

      console.log('updatePrices', window.prices.base);
      for (const plan in window.prices.base.monthly) {
        window.prices.base.monthly[plan] = Math.round(window.prices.base.monthly[plan] * countries[countryCode].conversion);
      }

      for (const plan in window.prices.base.yearly) {
        window.prices.base.yearly[plan] = Math.round(window.prices.base.yearly[plan] * countries[countryCode].conversion);
      }

      this.updateData();

      GAService.sendEvent('Currency', '', countries[countryCode].currencyCode);
      window.currency_code = countries[countryCode].currencyCode;
    }
  }

  fillPrices(couponData) {
    if (
      typeof window.prices["discount_" + couponData.percentOff] === "undefined"
    ) {
      window.prices["discount_" + couponData.percentOff] = {
        monthly: {},
        yearly: {},
      };
    }

    const businessPlans = ["start_up_q323", "agency_q123", "enterprise_q123"]
    for (
      let i = 0, plans = ["profit_q324", "scale_q324", "start_up_q323", "agency_q123", "enterprise_q123"];
      i < plans.length;
      i++
    ) {
      const planName = plans[i];
      for (let j = 0; j < 2; j++) {
        // Don't use overrides for business plans for simple partner pages with 30% percent off (!IMPORTANT)
        // @TODO add overrides to each coupon to make it more bulletproof
        // if (!(this.isPartnershipPage && couponData.percentOff === 30 && businessPlans.includes(plans[i]))) {
          const period = j === 0 ? "monthly" : "yearly";
          let price = PricingCalculator.getPlanPriceViaOverrides(
            planName,
            couponData.overrides,
            couponData.percentOff,
            period
          );

          window.prices["discount_" + couponData.percentOff][period][planName] = price;
          if (period === "yearly") {
            const upfrontPrice = PricingCalculator.getUpfrontPriceViaOverrides(
              planName,
              couponData.overrides,
              couponData.percentOff,
              period
            );

            window.prices["discount_" + couponData.percentOff][period][planName + "-upfront"] = upfrontPrice;
          }
        // }
      }
    }
    //bfcm 2024 partner prices hack
    if (!window.is_bfcm_promo_active) {
      this.setDiscount(couponData.percentOff);
    }
    this.updateData();
  }

  handleSwitchingPeriod() {
    this.$pricingSwitcher.find(".price-switcher__period").click((e) => {
      e.preventDefault();
      const period = $(e.currentTarget).data("period");

      if (this.period !== period) {
        this.switchPeriod(this.period, period);
        this.updateData();
      }
    });

    this.$pricingSwitcher.find(".price-switcher__btn").click((e) => {
      e.preventDefault();
      const period = this.period === this.periodsAvailable[0] ? this.periodsAvailable[1] : this.periodsAvailable[0];
      this.switchPeriod(this.period, period);
      this.updateData();
    });

    const period = getParameterByName("period");

    if (period) {
      this.$pricingSwitcher
        .find(`.price-switcher__period[data-period="${period}"]`)
        .click();
    }

    const hideSwitcher = getParameterByName("sw") === "off";

    if (hideSwitcher) {
      this.$pricingSwitcher.hide();
    }
  }

  handleSwitchingMode() {
    this.$modeSwitcher.find(".mode-switcher__slider-btn").click((e) => {
      e.preventDefault();
      const mode = $(e.currentTarget).data("mode");

      // if (this.mode === "business" || window.is_bf_promo_active) {
        this.$pricingLoadWrapper.css("opacity", 1);
      // }

      this.$modeSwitcher.removeClass((index, className) => {

        return className.match(/mode-switcher--(business|individual)/g);
      });

      this.$modeSwitcher.addClass(`mode-switcher--${mode}`);


      this.$pricing.removeClass((index, className) => {
        return className.match(/pricing-page--(business|individual)/g);
      });

      this.$pricing.addClass(`pricing-page--${mode}`);
      this.mode = mode;

      if (this.mode === 'business') {
        this.$businessDoodle.css('opacity', 0);
        this.$pricingSwitcher.css('opacity', 1);
        this.$pricingSwitcher.css('pointer-events', 'initial');

        // if (this.period === '6-months') {
        //   this.switchPeriod('6-months', 'yearly');
        // }
      } else if (this.mode === 'individual') {
        this.$businessDoodle.css('opacity', 1);

        // commenting out, because im restoring annuals for ind plans
        // if (!window.is_bfcm_promo_active) {
        //   this.switchPeriod('yearly', 'monthly');
        //   this.$pricingSwitcher.css('opacity', 0);
        //   this.$pricingSwitcher.css('pointer-events', 'none');
        // }

        // if (this.isPartnershipPage && this.period === 'yearly' && window.partner_version && window.partner_version === 'tombell') {
          
        // } else {
        //   if (this.period === 'monthly') {
        //     this.switchPeriod('monthly', '6-months');
        //   } else if (this.period === 'yearly') {
        //     this.switchPeriod('yearly', '6-months');
        //   }
        // }
      }

      // if (window.is_bf_promo_active) {
      //   const newPeriod = 'monthly';
      //
      //   if (this.period !== newPeriod) {
      //     this.switchPeriod(this.period, newPeriod);
      //   }
      //
      //   this.$pricingSwitcher.each((i, switcher) => {
      //     const $switcher = $(switcher);
      //     const isAlternate = $switcher.hasClass('price-switcher--alternate');
      //
      //     if (isAlternate) {
      //       $switcher.find('[data-period="yearly"]').find('.price-switcher__period--short').text(mode === 'individual' ? 'bf' : 'yr');
      //       $switcher.find('[data-period="yearly"]').find('.price-switcher__period--long').text(mode === 'individual' ? 'bfcm' : 'yearly');
      //     } else {
      //       $switcher.find('[data-period="yearly"]').html(mode === 'individual' ? '<span class="price-switcher__bfcm"><span>BFCM</span> deals</span>' : 'Yearly');
      //     }
      //     const text = mode === 'individual' ? (isAlternate ? 'BF' : 'Black Friday') : (isAlternate ? 'YR' : 'Yearly');
      //   });
      // }

      this.updateData();
    });

    this.$pricing.find('.overview-box--teased,.pricing-head__plan--teased').hover((e) => {
      this.$modeSwitcher.addClass('mode-switcher--business-teased');
    }, (e) => {
      this.$modeSwitcher.removeClass('mode-switcher--business-teased');
    })

    this.$pricing.find('[data-mode-switch]').click((e) => {
      this.switchMode($(e.currentTarget).data('modeSwitch'));
    });
  }

  switchMode(mode) {
    this.$modeSwitcher
      .find(`.mode-switcher__slider-btn[data-mode="${mode}"]`)
      .first()
      .click();
  }

  switchPeriod(oldPeriod, newPeriod) {
    // if (newPeriod === 'monthly' && this.mode === 'individual' && !this.isPartnershipPage && !window.partner_version && window.partner_version !== 'tombell') return;

    this.$pricing.removeClass("pricing-page--" + oldPeriod);
    this.$pricing.addClass("pricing-page--" + newPeriod);

    this.$pricingSwitcher
      .find('[data-period="' + oldPeriod + '"]')
      .removeClass("price-switcher__period--active");
    this.$pricingSwitcher
      .find('[data-period="' + newPeriod + '"]')
      .addClass("price-switcher__period--active");

    this.$pricingSwitcher.removeClass("price-switcher--" + oldPeriod);
    this.$pricingSwitcher.addClass("price-switcher--" + newPeriod);

    this.period = newPeriod;
  }

  handleOpeningComparison() {
    this.$comparisonSwitcher.click((e) => {
      e.preventDefault();

      const toggleClass = $(e.currentTarget).data("toggle");
      const $toggleableElements = this.$pricing.find("." + toggleClass);

      if (this.isComparisonOpen) {
        $toggleableElements.hide();
        this.$comparisonSwitcher.removeClass("text-btn--open");
        this.$comparisonSwitcher.text(this.translations.open_comparison);
      } else {
        $toggleableElements.show();
        this.$comparisonSwitcher.addClass("text-btn--open");
        this.$comparisonSwitcher.text(this.translations.close_comparison);
        this.initSlick();
      }

      this.computeOffsets();
      this.isComparisonOpen = !this.isComparisonOpen;
    });
  }

  handleRegistration() {
    const registrationUrl =
      window.registration_base_url ||
      window.location.protocol + "//" + window.location.hostname + "/register/";

    this.$pricing.on("click", ".register-button", (e) => {
      e.preventDefault();

      const planName = $(e.currentTarget)
        .closest("[data-price-container]")
        .data("planName");

      //route to registration
      let registrationParams = window.registration_data ? JSON.parse(JSON.stringify(window.registration_data)) : {};
      registrationParams.plan = planName;
      registrationParams.period = this.period;

      if (planName === 'profit_q224' && this.period === '6-months') {
        registrationParams.plan = 'ANNUAL06_PROFIT_Q224_$1074';
        registrationParams.period = '6-months';
        registrationParams.private = true;
      } else if (planName === 'scale_q224' && this.period === '6-months') {
        registrationParams.plan = 'ANNUAL06_SCALE_Q224_$1794';
        registrationParams.period = '6-months';
        registrationParams.private = true;
      }

      if (window.currency_code) {
        registrationParams.c = window.currency_code;
      }

      if (window.custom_plans_map) {
        if (window.custom_plans_map[`${planName}_${this.period}`]) {
          const planData = window.custom_plans_map[`${planName}_${this.period}`];

          registrationParams.plan = planData.plan;
          registrationParams.coupon = planData.coupon;
          registrationParams.private = true;
          delete registrationParams.period;
        }
      }

      window.location.href =
        registrationUrl + "?" + $.param(registrationParams);
    });
  }

  handleContactForm() {
    this.$pricing.on("click", "[data-toggle-contact]", (e) => {
      e.preventDefault();
      const planName = $(e.currentTarget).data('toggleContact');
      this.pricingContactForm.openForm(planName);
    });
  }
  
  initSlick() {
    if (!this.slickInitialized) {
      this.$slider.on("init", () => {
        this.computeOffsets();
        this.$slider.addClass("slick-slider--1");
        this.choosePlan(this.isMobile ? this.mobilePricingFirstPlan : this.currentPlanIndex, false);
        // this.choosePlan(this.currentPlanIndex, false);
      });

      this.$slider.on("afterChange", (e, sl, cur) => {
        this.choosePlan(cur + (this.mode === 'business' ? 3 : 0), false);
      });

      this.$slider.on("beforeChange", (e, sl, cur, next) => {
        this.$slider.removeClass("slick-slider--1");
        if (next === 1) {
          this.$slider.addClass("slick-slider--1");
        }
      });

      this.$slider.on("init", (event, slick) => {
        let $firstSlide = this.$slider.find(
          '.slick-slide[data-slick-index="0"]'
        );

        if ($firstSlide.length)
          $firstSlide.find(".overview-box").addClass("overview-box--active");
      });

      this.$slider.slick({
        autoplay: false,
        // centerMode: true,
        centerMode: false,
        infinite: false,
        initialSlide: 1,
        // slidesPerRow: 3,
        slidesToShow: 3,
        variableWidth: true,
        touchThreshold: 12,
        swipeToSlide: true,
        arrows: true,
        prevArrow:
          '<span class="pricing-overview__arrow pricing-overview__arrow--left"></span>',
        nextArrow:
          '<span class="pricing-overview__arrow pricing-overview__arrow--right"></span>',
        dots: false,
        responsive: [
          {
            breakpoint: 960,
            settings: {
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              centerMode: true
            }
          },
        ]
      });

      this.canSlide = true;
      this.slickInitialized = true;

      this.$comparisonSilder.on("afterChange", (e, sl, cur) => {
        const planIndex = (this.mode === 'business' ? 3 : 0) + cur;

        this.$desktopPricing.find(".pricing-row:not(.pricing-row--group)").each((i, row) => {
          $(row).find(`.pricing-row__cell.data-${this.mode}`).each((j, cell) => {
            $(cell).html(this.comparisonData[i][this.allPlans[planIndex + j]]);
          });
        });
      });

      this.$comparisonSilder.slick({
        autoplay: false,
        centerMode: false,
        infinite: false,
        initialSlide: 0,
        // slidesPerRow: 3,
        slidesToShow: 3,
        variableWidth: true,
        touchThreshold: 12,
        swipeToSlide: true,
        arrows: true,
        prevArrow:
          '<span class="pricing-head__arrow pricing-head__arrow--left"></span>',
        nextArrow:
          '<span class="pricing-head__arrow pricing-head__arrow--right"></span>',
        dots: false
      });
    }
    
  }

  updateData() {
    this.updatePrices();
    this.updateCTAs();
    // console.log(this.currentPlanIndex);
    this.choosePlan(this.currentPlanIndex);
    this.makeOverviewSectionsEqualHeight();
  }

  updatePrices() {
    if (this.discount === null) return;
    this.discountedPlans = [];

    let prices = window.prices;

    const $priceContainer = this.$pricing.find("[data-price-container]");

    $priceContainer.each((index, element) => {
      const planName = $(element).data("planName");
      const discountLabel =
        this.discount > 0 ? "discount_" + this.discount : "base";
      const period = this.period;

      const price = prices[discountLabel][period][planName];
      let periodText = period === "monthly" ? '' : (period === "6-months" ? 'billed semi-annually' : this.translations.billed);

      $(element)
        .find("[data-price]")
        .text(price);
      $(element)
        .find("[data-period]")
        .html(periodText);

      if (
        this.custom_label_appearance &&
        this.custom_label_appearance.indexOf(planName + "_" + period) !== -1
      ) {
        $(element).addClass("show-custom-label");
      } else {
        $(element).removeClass("show-custom-label");
      }

      if (
        prices[discountLabel][period][planName] &&
       (prices[discountLabel][period][planName] !==
        prices["base"][period][planName])
      ) {
        // commenting out: might be useful for showing discount percentages in the future
        let discount = Math.ceil(
          100 -
            (prices[discountLabel][period][planName] /
              prices["base"]["monthly"][planName]) *
              100
        );

        $(element)
          .find("[data-old-price]")
          // .show()
          .css("visibility", "visible")
          .text("$" + prices["base"][period][planName]);

        this.discountedPlans.push(planName + "_" + period);
      } else {
        $(element).find("[data-old-price]").css("visibility", "hidden");

        $(element).find("[data-percentage-label]").css("visibility", "hidden");
      }
    });
  }

  updateCTAs() {
    const $priceContainer = this.$pricing.find("[data-price-container]");

    $priceContainer.each((index, element) => {
      const planName = $(element).data("planName");

      // commenting out: might be useful for showing discount percentages in the future
      // if (window.is_xmas_promo_active) {
      //   const discountLabel =
      //     this.discount > 0 ? "discount_" + this.discount : "base";
      //   const period = this.period;
      //   if (
      //     prices[discountLabel][period][planName] &&
      //     prices[discountLabel][period][planName] !==
      //     prices["base"][period][planName]
      //   ) {
      //     const discount = Math.ceil(100 - prices[discountLabel][period][planName] / prices["base"][period][planName] * 100);
      //     $(element)
      //       .find(".register-button")
      //       .text(`Save ${discount}% Now!`);
      //   }
      // }

      $(element)
        .find(".new-btn")
        .attr("data-gtm", planName + "_" + this.period);
    });
  }

  setDiscount(discount) {
    this.discount = discount;
    this.updateData();
  }

  setupABTest() {
    //initialize just to clear data
    const abTest = new PricingABTest();
  }

  fetchMode() {
    $.ajax("https://plans-info.voluum.com")
      .done((response) => {
        if (response.plans === "individual") {
          this.mode = "individual";
          this.switchMode("individual");
          window.dataLayer.push({ plan_cat: "ind" });
        } else {
          this.mode = "business";
          this.switchMode("business");
          window.dataLayer.push({ plan_cat: "biz" });
        }
      })
      .fail(() => {
        this.mode = "business";
        this.switchMode("business");
        window.dataLayer.push({ plan_cat: "biz_err_fallback" });
      });
  }

  overrideGuruMedia() {
    if(this.partnerName === "GuruMedia") {
      
      let promotedOverviewBox = null;
      promotedOverviewBox = Array.from(document.querySelectorAll(".overview-box")).find(box => box.dataset.planName === "scale_q324");
      promotedOverviewBox.classList.add('promoted');

      const handleGuruMediaPeriodSwitch = (e) => {
        document.querySelectorAll(".overview-box").forEach(box => box.classList.remove("promoted"));

        if(this.period === "monthly") {
          promotedOverviewBox = Array.from(document.querySelectorAll(".overview-box")).find(box => box.dataset.planName === "scale_q324");
        } else {
          promotedOverviewBox = Array.from(document.querySelectorAll(".overview-box")).find(box => box.dataset.planName === "profit_q324");
        }

        promotedOverviewBox.classList.add('promoted');
      }
      
      this.$pricingSwitcher.find(".price-switcher__period").on("click", handleGuruMediaPeriodSwitch)
      this.$pricingSwitcher.find(".price-switcher__btn").on("click", handleGuruMediaPeriodSwitch)
    }
  }
}
